import { Button } from "@mui/material";
import React from "react";
import { VarianceStartCommand } from "../../../../../services/varianceService/commands";
import { useStartPatientVarianceMutation } from "../../../../../services/varianceService/variance-api";
import { Individual } from "../../../../../services/varianceService/model";
import { useNavigate, useParams } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { setVarianceIndividual } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import {
  toggleIdentificationDetailsDialog,
  toggleInitiatePatientSearchDialog,
} from "../../../../../app/slices/VarianceModuleSlice";
import { DefaultVarianceRequest } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequest";

function VarianceInititiateIndividualCommand(individual: Individual) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const varianceStart = DefaultVarianceRequest();

  Object.assign(varianceStart, variance);
  varianceStart.individual = { ...variance.individual };
  varianceStart.varianceStartDate = new Date().toISOString();

  const saveIdent = () => {
    dispatch(setVarianceIndividual(individual));
    startVariance();
    dispatch(toggleIdentificationDetailsDialog());
    if (variance.individual.individualType === "Patient")
      dispatch(toggleInitiatePatientSearchDialog());
  };
  const [initiate] = useStartPatientVarianceMutation();

  const startVariance = () => {
    const command = new VarianceStartCommand(varianceStart);
    initiate(command)
      .unwrap()
      .then((fullfilled) => {
        navigate("/varianceRequestDetail/" + fullfilled.id);
      });
  };

  return (
    <React.Fragment>
      <Button
        onClick={() => {
          saveIdent();
        }}
      >
        Submit
      </Button>
    </React.Fragment>
  );
}

export { VarianceInititiateIndividualCommand };
